@if (!child) {
  <div
    [ngClass]="{
      'app-horizontal-nav-menu-active': trigger.opened,
      'app-horizontal-nav-menu-active-forced': item.active
    }"
    [matMenuTriggerFor]="matMenu"
    (opened)="triggerChangeDetection()"
    (closed)="triggerChangeDetection()"
    #trigger="matMenuTrigger">
    <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: item }"></ng-container>
  </div>
}

<mat-menu class="app-horizontal-nav-menu-panel" [overlapTrigger]="false" #matMenu="matMenu">
  @for (childItem of item.children; track trackByFn($index, childItem)) {
    @if ((childItem.hidden && !childItem.hidden(childItem)) || !childItem.hidden) {
      @if (childItem.type === 'basic') {
        <div class="app-horizontal-nav-menu-item" [disabled]="childItem.disabled" mat-menu-item>
          <app-horizontal-nav-basic-item [item]="childItem" [name]="name"></app-horizontal-nav-basic-item>
        </div>
      }
      @if (childItem.type === 'aside' || childItem.type === 'collapsable' || childItem.type === 'group') {
        <div class="app-horizontal-nav-menu-item" [disabled]="childItem.disabled" [matMenuTriggerFor]="branch.matMenu" mat-menu-item>
          <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: childItem }"></ng-container>
          <app-horizontal-nav-branch-item [child]="true" [item]="childItem" [name]="name" #branch></app-horizontal-nav-branch-item>
        </div>
      }
    }
  }
</mat-menu>

<ng-template let-item #itemTpl>
  <div class="app-horizontal-nav-item-wrapper" [class.app-horizontal-nav-item-has-subtitle]="!!item?.subtitle" [ngClass]="item?.classes?.wrapper">
    <div
      class="app-horizontal-nav-item"
      [class.app-horizontal-nav-item-disabled]="item?.disabled"
      [class.app-horizontal-nav-item-active-forced]="item?.active"
      [matTooltip]="item?.tooltip || ''">
      @if (item?.icon) {
        <mat-icon class="app-horizontal-nav-item-icon" [ngClass]="item?.classes?.icon" [svgIcon]="item.icon"></mat-icon>
      }
      <div class="app-horizontal-nav-item-title-wrapper">
        <div class="app-horizontal-nav-item-title"><span [ngClass]="item?.classes?.title">{{ item?.title }}</span></div>
        @if (item?.subtitle) {
          <div class="app-horizontal-nav-item-subtitle"><span [ngClass]="item?.classes?.subtitle">{{ item?.subtitle }}</span></div>
        }
      </div>
      @if (item?.badge) {
        <div class="app-horizontal-nav-item-badge"><div class="app-horizontal-nav-item-badge-content" [ngClass]="item.badge.classes">{{ item.badge.title }}</div></div>
      }
    </div>
  </div>
</ng-template>
